import { useMemo } from 'react';

import useGenericRetriever, {
  type UseGenericRetrieverParams,
} from '@/hooks/requests/useGenericRetriever';
import type { Statuses } from '@/contexts/Status/StatusContext';

export type SystemStatusResponse = {
  status: (typeof Statuses)[keyof typeof Statuses];
  db: string;
  clinicalApi: string;
  timestamp: string;
  message?: string; // if status' not ok
  onschedToken?: string;
};

function useSystemStatusRequest({ enabled = true }: { enabled?: boolean }) {
  const queryOptions = useMemo<UseGenericRetrieverParams<SystemStatusResponse>>(
    () => ({
      url: '/health',
      queryKey: ['system-status'],
      withAuth: false,
      queryOptions: {
        refetchInterval: 120000,
        retry: false,
      },
      extraQueryOptions: {
        returnError: true,
      },
      enabled,
    }),
    [enabled]
  );

  return useGenericRetriever<SystemStatusResponse>(queryOptions);
}

export default useSystemStatusRequest;
